import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page-header",
  role: "banner"
}
const _hoisted_2 = { class: "page-logo" }
const _hoisted_3 = { class: "ml-auto d-flex" }
const _hoisted_4 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/dashboard" }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("img", {
              src: "img/logo.png",
              alt: "furukawa logo",
              "aria-roledescription": "logo"
            }, null, -1)
          ])),
          _: 1,
          __: [3]
        }),
        _cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "page-logo-text mr-1",
          style: {"color":"#073190"}
        }, " フュージョンアウトドア 業務管理システム ", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "position-absolute text-white opacity-50 small pos-top pos-right mr-2 mt-n2" }, null, -1))
      ]),
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"hidden-md-down dropdown-icon-menu position-relative\" data-v-702cf7d4><a href=\"#\" class=\"header-btn btn js-waves-off\" data-action=\"toggle\" data-class=\"nav-function-hidden\" title=\"Hide Navigation\" data-v-702cf7d4><i class=\"ni ni-menu\" data-v-702cf7d4></i></a><ul data-v-702cf7d4><li data-v-702cf7d4><a href=\"#\" class=\"btn js-waves-off\" data-action=\"toggle\" data-class=\"nav-function-minify\" title=\"Minify Navigation\" data-v-702cf7d4><i class=\"ni ni-minify-nav\" data-v-702cf7d4></i></a></li><li data-v-702cf7d4><a href=\"#\" class=\"btn js-waves-off\" data-action=\"toggle\" data-class=\"nav-function-fixed\" title=\"Lock Navigation\" data-v-702cf7d4><i class=\"ni ni-lock-nav\" data-v-702cf7d4></i></a></li></ul></div><div class=\"hidden-lg-up\" data-v-702cf7d4><a href=\"#\" class=\"header-btn btn press-scale-down\" data-action=\"toggle\" data-class=\"mobile-nav-on\" data-v-702cf7d4><i class=\"ni ni-menu\" data-v-702cf7d4></i></a></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light waves-effect waves-themed",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal4logout()))
          }, " ログアウト ")
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_logout" }, {
      title: _withCtx(() => _cache[7] || (_cache[7] = [
        _createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1),
        _createElementVNode("span", { class: "text-success fw-500" }, "ログアウトします。よろしいですか？", -1)
      ])),
      body: _withCtx(() => _cache[8] || (_cache[8] = [
        _createElementVNode("br", null, null, -1)
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal4logout())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}